import * as z from 'zod';
import { RECURRING_FREQUENCIES } from '@/lib/constants/recurring';

export const CreateInvoiceSchema = z
  .object({
    id: z.string().optional(),
    clientId: z.string().min(1, {
      message: 'Client is required!',
    }),
    invoiceNumber: z.string().min(1, { message: 'Invoice number required!' }),
    invoiceType: z.string().min(1, { message: 'Invoice type required!' }),
    status: z.enum(['PAID', 'UNPAID', 'SENT', 'OVERDUE']),

    serviceDate: z.object({
      from: z.date({ message: 'Service start date is required!' }),
      to: z.date().optional(),
    }),
    serviceYear: z.number().optional(), // Year extracted on client to avoid timezone issues
    dueDate: z.date({ message: 'Due date is required!' }),
    issuedDate: z.date(),

    items: z
      .object({
        description: z.string().min(1, {
          message: 'Description is required!',
        }),
        qty: z.number().positive({
          message: 'Quantity must be greater than 0',
        }),
        unit: z.string(),
        price: z.number().positive({
          message: 'Price must be greater than 0',
        }),
        tax: z.number().min(0).max(100, {
          message: 'Tax must be between 0 and 100',
        }),
        total: z.number().positive({
          message: 'Total must be greater than 0',
        }),
      })
      .array()
      .min(1, {
        message: 'At least one item is required!',
      }),

    ddvAdditionalInput: z.string().optional(),

    // Recurring
    isRecurring: z.boolean().optional(),
    recurringFrequency: z.enum(RECURRING_FREQUENCIES).optional(),
    recurringNextDate: z.date().optional(),
    recurringEndDate: z.date().optional().nullable(),
  })
  .refine(
    (data) => {
      if (!data.isRecurring) return true;
      return !!data.recurringFrequency && !!data.recurringNextDate;
    },
    {
      message: 'Recurring requires frequency and next date',
      path: ['recurringNextDate'],
    }
  );
